<p>
  statistics works!
</p>
